import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { login as loginAPI } from '../utils/api';
import api from '../utils/api';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [installPrompt, setInstallPrompt] = useState(null);
  const [showInstallBanner, setShowInstallBanner] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  // Pre-warm the backend so it's ready by the time credentials are submitted
  useEffect(function() {
    api.get('/health').catch(function() {});
  }, []);

  useEffect(function() {
    var handler = function(e) {
      e.preventDefault();
      setInstallPrompt(e);
      setShowInstallBanner(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return function() { window.removeEventListener('beforeinstallprompt', handler); };
  }, []);

  var handleInstall = async function() {
    if (!installPrompt) return;
    installPrompt.prompt();
    var result = await installPrompt.userChoice;
    if (result.outcome === 'accepted') setShowInstallBanner(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await loginAPI({ email, password });
      login(res.data.token, res.data.user);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      {/* PWA Install Banner */}
      {showInstallBanner && (
        <div style={{
          background: '#eafaf1', border: '1px solid #4a8f82',
          borderRadius: '8px', padding: '12px 16px',
          marginBottom: '20px', display: 'flex',
          justifyContent: 'space-between', alignItems: 'center',
          maxWidth: '420px', width: '100%', boxSizing: 'border-box'
        }}>
          <div>
            <div style={{ fontFamily: "'Raleway', sans-serif", fontSize: '13px', fontWeight: '700', color: '#1a1a2e', marginBottom: '2px' }}>
              Install PWC Oneness App
            </div>
            <div style={{ fontSize: '12px', color: '#666' }}>
              Add to your home screen for quick access
            </div>
          </div>
          <button onClick={handleInstall} style={{
            background: '#4a8f82', color: '#fff', border: 'none',
            borderRadius: '4px', padding: '8px 16px',
            fontFamily: "'Raleway', sans-serif",
            fontSize: '12px', fontWeight: '700',
            cursor: 'pointer', flexShrink: 0, marginLeft: '12px'
          }}>
            Install
          </button>
        </div>
      )}

      <div style={styles.card}>
        {/* Logo */}
        <div style={styles.logoWrap}>
          <img
            src="https://pranicwellnesscentre.com/wp-content/uploads/2018/10/PH-Revised-Logo.png"
            alt="Pranic Wellness Centre"
            style={styles.logo}
          />
        </div>

        {/* Title */}
        <div style={styles.titleWrap}>
          <h1 style={styles.title}>PWC Oneness with All</h1>
          <p style={styles.subtitle}>Pranic Wellness Centre — Member Portal</p>
          <div style={styles.rule}></div>
        </div>

        {/* Error */}
        {error && <div style={styles.error}>{error}</div>}

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div style={styles.field}>
            <label style={styles.label}>Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
              placeholder="Enter your email"
              required
            />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input}
              placeholder="Enter your password"
              required
            />
          </div>
          <button
            type="submit"
            style={loading ? { ...styles.btn, opacity: 0.7 } : styles.btn}
            disabled={loading}
          >
            {loading ? 'Signing In...' : 'Sign In to Portal'}
          </button>
        </form>

        {/* Divider */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', margin: '24px 0 20px' }}>
          <div style={{ flex: 1, height: '1px', background: 'rgba(255,255,255,0.1)' }}></div>
          <span style={{ fontSize: '11px', color: 'rgba(255,255,255,0.3)', fontFamily: "'Raleway', sans-serif", letterSpacing: '1px', textTransform: 'uppercase' }}>or</span>
          <div style={{ flex: 1, height: '1px', background: 'rgba(255,255,255,0.1)' }}></div>
        </div>

        {/* Login via Website */}
        <a
          href="https://pranicwellnesscentre.com/react-redirect/"
          style={{
            display: 'block', width: '100%', padding: '13px',
            background: 'transparent', color: '#8DC63F',
            border: '1px solid rgba(141,198,63,0.4)', borderRadius: '5px',
            fontFamily: "'Raleway', sans-serif", fontSize: '12px', fontWeight: '700',
            letterSpacing: '1.5px', textTransform: 'uppercase',
            textAlign: 'center', textDecoration: 'none', boxSizing: 'border-box'
          }}
        >
          Login via Pranic Wellness Centre
        </a>

        {/* Footer */}
        <div style={styles.footer}>
          Pranic Wellness Centre, Perungudi, Chennai
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #071e12 0%, #0a1f14 30%, #0c2617 60%, #071e12 100%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    fontFamily: "'Open Sans', sans-serif"
  },
  card: {
    background: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: '16px',
    padding: '48px 40px',
    width: '100%',
    maxWidth: '420px',
    backdropFilter: 'blur(20px)',
    boxShadow: '0 8px 32px rgba(0,0,0,0.3)'
  },
  logoWrap: {
    textAlign: 'center',
    marginBottom: '24px'
  },
  logo: {
    height: '56px',
    margin: '0 auto',
    filter: 'drop-shadow(0 2px 8px rgba(141,198,63,0.3))'
  },
  titleWrap: {
    textAlign: 'center',
    marginBottom: '32px'
  },
  title: {
    fontFamily: "'Raleway', sans-serif",
    fontSize: '22px',
    fontWeight: '800',
    color: '#fff',
    margin: '0 0 8px',
    letterSpacing: '0.5px'
  },
  subtitle: {
    fontSize: '12px',
    color: 'rgba(255,255,255,0.4)',
    margin: '0 0 16px',
    letterSpacing: '1.5px',
    textTransform: 'uppercase'
  },
  rule: {
    width: '40px',
    height: '2px',
    background: 'linear-gradient(to right, #00AEEF, #4a8f82, #8DC63F)',
    margin: '0 auto'
  },
  error: {
    background: 'rgba(192,57,43,0.2)',
    border: '1px solid rgba(192,57,43,0.4)',
    borderRadius: '6px',
    padding: '12px 16px',
    color: '#e74c3c',
    fontSize: '13px',
    marginBottom: '20px'
  },
  field: {
    marginBottom: '18px'
  },
  label: {
    display: 'block',
    fontSize: '10px',
    fontWeight: '700',
    letterSpacing: '1.5px',
    textTransform: 'uppercase',
    color: 'rgba(255,255,255,0.45)',
    marginBottom: '7px',
    fontFamily: "'Raleway', sans-serif"
  },
  input: {
    width: '100%',
    padding: '12px 14px',
    background: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(255,255,255,0.12)',
    borderRadius: '5px',
    color: '#fff',
    fontSize: '14px',
    outline: 'none',
    boxSizing: 'border-box',
    fontFamily: "'Open Sans', sans-serif"
  },
  btn: {
    width: '100%',
    padding: '13px',
    background: '#4a8f82',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    fontFamily: "'Raleway', sans-serif",
    fontSize: '12px',
    fontWeight: '700',
    letterSpacing: '1.5px',
    textTransform: 'uppercase',
    cursor: 'pointer',
    marginTop: '8px'
  },
  footer: {
    textAlign: 'center',
    marginTop: '24px',
    fontSize: '11px',
    color: 'rgba(255,255,255,0.25)'
  }
};

export default Login;